module.exports = {"140921100":"晋昌镇","140921101":"河边镇","140921102":"宏道镇","140921103":"季庄镇","140921104":"蒋村镇","140921201":"南王乡","140921203":"神山乡","140921205":"受禄乡","140921400":"定襄县居民"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140921.json
// module id = 435
// module chunks = 0